var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"ticket-new ticket-new-w",on:{"click":_vm.showPopupBox}},[_c('h4',{staticClass:"ticket-number"},[_vm._v("自定义")]),_vm._v(" "),_c('p',{staticClass:"ticket-money"},[_vm._v("请输入充值金额")])])}
var staticRenderFns = []

export { render, staticRenderFns }